export default __webpack_public_path__ + "static/media/languages-icon.f7ea1615.svg";